<ejs-grid #valueReplacementGrid
          width="100%"
          rowHeight="38"
          [dataSource]="fieldValueReplacements()"
          height="600px"
          [allowSorting]="false"
          [editSettings]='editSettings'
          [allowPaging]="false"
          (load)='onValueReplacementGridLoad($event)'
          (created)="onGridCreated()"
          [selectionSettings]='selectionOptions'
          (commandClick)="valueReplacementGridCommandClicked($event)"
          [toolbar]="valueGridToolBar"
          [enableStickyHeader]="true"
          (rowDataBound)="valueReplacementGridRowDataBound($event)"
          (cellSaved)="onCellSaved($event)"
          (beforeBatchAdd)="onBeforeBatchAdd($event)"
          (batchAdd)="onBatchAdd($event)"
          (beforeBatchSave)="onBeforeBatchSave($event)">
  <ng-template #toolbarTemplate let-data>
    @if (!!fieldValueReplacements) {
      <ejs-toolbar (clicked)='valueReplacementToolClicked($event)'>
        <e-items>
          <e-item id="paste"
                  text="{{'i18n.domain.export-configuration.field-value-replacements.field-replacement-grid.paste-button' | translate}}"
                  title="{{'i18n.domain.export-configuration.field-value-replacements.field-replacement-grid.paste-button-tooltip' | translate}}"
                  prefixIcon="e-paste icon">
          </e-item>
        </e-items>
      </ejs-toolbar>
    }
  </ng-template>
  <e-columns>
    <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
    <e-column field="sourceValue"
              headerText="{{'i18n.domain.export-configuration.field-value-replacements.field-replacement-grid.value' | translate}}"
              clipMode="EllipsisWithTooltip"
              type="string"
              id="sourceValue">
    </e-column>
    <e-column field="origSourceValue" [visible]="false" type="string"></e-column>
    <e-column field="replacementValue"
              headerText="{{'i18n.domain.export-configuration.field-value-replacements.field-replacement-grid.replacement' | translate}}"
              clipMode="EllipsisWithTooltip"
              type="string"
              columnName="replacementValue">
    </e-column>
    <e-column field="origReplacementValue" [visible]="false" type="string"></e-column>
    <e-column headerText="" [commands]='fieldsGridCommands' width='60px'></e-column>
  </e-columns>
</ejs-grid>
